import { Box, Button, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import pemdingLeaguesIcon from "../../../styles/images/pendingLeagueIcon.svg";
import activeLeagueIcon from "../../../styles/images/activeLeagueIcon.svg";
import { useParams } from "react-router-dom";

import {
    getLeagueSeasons,
    updateLeague,
} from "../../../services/leagues";
import toast from "react-hot-toast";
import SeasonTable from "../../my_leagues/leagueByID/seasonTable";
import JoinedLeagueTable from "./JoinedLeagueTable";

export default function JoinedDetail() {
    const { id: league_id } = useParams();
    const [data, setData] = useState([]);
    const [refetch, setRefetch] = useState(false);
    const [editLeagueName, setEditLeagueName] = useState(false);
    const [loading, setLoading] = useState(false);

    // Data fetching function
    const fetchData = async () => {
        try {
            const response = await getLeagueSeasons(league_id);
            setData({ ...response.data, results: response.data.results.map(result => ({ ...result, id: result.season_id })) });

        } catch (err) {
            console.log("in catch joined league fetch === ", err);
            // setError("Failed to fetch data");
        } finally {
            // setLoading(false);
        }
    };
    console.log("data === ", data);
    useEffect(() => {
        fetchData();
    }, [refetch]);

    return (
        <div>
            <div className="league-header">
                <img
                    className="league-header-image"
                    src={
                        data?.league_status === "Upcoming"
                            ? pemdingLeaguesIcon
                            : activeLeagueIcon
                    }
                    alt="league"
                />
                <div className="league-header-content">
                    <p className="heading-title">{data?.league_name}</p>

                    <p>{data?.description}</p>

                </div>
            </div>

            {data?.league_status !== "Upcoming" && (
                <div>
                    <div className="league-header mt-4">
                        <div className="league-header-content">
                            <p className="heading-title-players">Seasons</p>
                        </div>
                    </div>
                    {/* <SeasonTable refetch={refetch} setRefetch={setRefetch} /> */}
                    <JoinedLeagueTable data={data?.results} loading={loading} totalRecords={data?.results?.length} />
                </div>
            )}
        </div>
    );
}
